var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [
                _vm._v(" " + _vm._s(_vm.$ct("titles.default")) + " "),
              ]),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        {
                          style: { position: "relative" },
                          attrs: { xs: "12" },
                        },
                        [
                          _vm.showEditor
                            ? _c(
                                "div",
                                {
                                  style: {
                                    display: "flex",
                                    flexDirection: "row",
                                  },
                                },
                                [
                                  _c("app-input-with-textarea-modal", {
                                    style: { flexGrow: 1, marginRight: "10px" },
                                    attrs: {
                                      editor: true,
                                      value: _vm.product.Name,
                                      label: _vm.$ct("labels.description"),
                                      fancy: "",
                                      "modal-title":
                                        _vm.$ct("labels.description"),
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.setProductDescription($event)
                                      },
                                    },
                                  }),
                                  _c(
                                    "w-button",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value:
                                            _vm.$ct(`tooltip.translations`),
                                          expression:
                                            "$ct(`tooltip.translations`)",
                                        },
                                      ],
                                      staticClass: "cancel",
                                      on: {
                                        click: function ($event) {
                                          _vm.translatedNamesModal = true
                                        },
                                      },
                                    },
                                    [_c("w-fa", { attrs: { icon: "globe" } })],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _c("w-textarea-autogrow", {
                                attrs: {
                                  value: _vm.product.Name,
                                  label: _vm.$ct("labels.description"),
                                  fancy: "",
                                  autofocus: "",
                                  icon: "globe-africa",
                                  "icon-tooltip":
                                    _vm.$ct(`tooltip.translations`),
                                  "min-height": 45,
                                },
                                on: {
                                  "icon-click": function ($event) {
                                    _vm.translatedNamesModal = true
                                  },
                                  input: function ($event) {
                                    return _vm.setProductDescription($event)
                                  },
                                },
                              }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: _vm.skuAndBarcodeMd } },
                        [
                          _c("w-input", {
                            attrs: {
                              disabled: _vm.product.ID > 0 || _vm.skuDisabled,
                              label: _vm.$ct("labels.sku"),
                              fancy: "",
                              upper: "",
                              "has-error": _vm.hasSkuError,
                            },
                            on: {
                              blur: function ($event) {
                                return _vm.verifySku()
                              },
                            },
                            model: {
                              value: _vm.product.Sku,
                              callback: function ($$v) {
                                _vm.$set(_vm.product, "Sku", $$v)
                              },
                              expression: "product.Sku",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: _vm.skuAndBarcodeMd } },
                        [
                          _c("w-input", {
                            attrs: {
                              label: _vm.$ct("labels.barcode"),
                              fancy: "",
                              "has-warning": _vm.barCodeExists,
                              icon: _vm.generateBarCodeIcon,
                              "icon-tooltip": _vm.$ct(
                                "generate-random-barcode"
                              ),
                            },
                            on: {
                              "icon-click": function ($event) {
                                return _vm.generateRandomBarCode()
                              },
                              blur: function ($event) {
                                return _vm.checkIfBarCodeExists()
                              },
                            },
                            model: {
                              value: _vm.product.BarCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.product, "BarCode", $$v)
                              },
                              expression: "product.BarCode",
                            },
                          }),
                          _c(
                            "w-transition-slide-height",
                            [
                              _vm.barCodeExists
                                ? _c(
                                    "app-error-message-box",
                                    { attrs: { "is-warning": "" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$ct(
                                            "bar-code-in-use-by-other-product"
                                          )
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.showQty2
                        ? _c(
                            "w-col",
                            { attrs: { xs: "12", md: "4" } },
                            [
                              _c("w-input-number", {
                                attrs: {
                                  fancy: "",
                                  decimals: _vm.decimalSettings.Qty2,
                                  label: _vm.defaultValueQty2Label,
                                },
                                model: {
                                  value: _vm.product.DefaultValueQty2,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.product,
                                      "DefaultValueQty2",
                                      $$v
                                    )
                                  },
                                  expression: "product.DefaultValueQty2",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "w-col",
                        { attrs: { md: "6", xs: "12" } },
                        [
                          _c("w-input-number", {
                            attrs: {
                              min: 0,
                              label: _vm.$ct("weight-per-unit"),
                              fancy: "",
                              decimals: 3,
                            },
                            model: {
                              value: _vm.product.Weight,
                              callback: function ($$v) {
                                _vm.$set(_vm.product, "Weight", $$v)
                              },
                              expression: "product.Weight",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.showUnitSelect
                        ? _c(
                            "w-col",
                            { attrs: { md: "6", xs: "12" } },
                            [
                              _c("app-select-unit", {
                                attrs: {
                                  value: _vm.product.UnitID,
                                  label: _vm.$ct("unit"),
                                  fancy: "",
                                  "use-ids": "",
                                },
                                on: {
                                  blur: function ($event) {
                                    return _vm.onUnitBlur($event)
                                  },
                                  select: function ($event) {
                                    return _vm.onUnitSelect($event)
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "w-col",
                        {
                          style: { display: "flex", justifyContent: "center" },
                          attrs: { xs: "12" },
                        },
                        [
                          _c("w-checkbox", {
                            attrs: { label: _vm.$ct("labels.active") },
                            model: {
                              value: _vm.product.Active,
                              callback: function ($$v) {
                                _vm.$set(_vm.product, "Active", $$v)
                              },
                              expression: "product.Active",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        {
                          style: { display: "flex", justifyContent: "center" },
                          attrs: { xs: "12" },
                        },
                        [
                          _c("w-checkbox", {
                            attrs: {
                              label: _vm.$ct("labels.disableDiscounts"),
                            },
                            model: {
                              value: _vm.product.DiscountsDisabled,
                              callback: function ($$v) {
                                _vm.$set(_vm.product, "DiscountsDisabled", $$v)
                              },
                              expression: "product.DiscountsDisabled",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        {
                          style: { display: "flex", justifyContent: "center" },
                          attrs: { xs: "12" },
                        },
                        [
                          _c("w-checkbox", {
                            attrs: {
                              label: _vm.$ct("labels.serial-number-required"),
                            },
                            model: {
                              value: _vm.product.SerialNumberRequired,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.product,
                                  "SerialNumberRequired",
                                  $$v
                                )
                              },
                              expression: "product.SerialNumberRequired",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [_c("app-sell-prices", { attrs: { product: _vm.product } })],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [_c("app-product-edit-groups", { attrs: { product: _vm.product } })],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c("app-product-edit-accounting", {
            style: { flexGrow: 1 },
            attrs: { product: _vm.product },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("images")))]),
              _c(
                "w-card-content",
                [_c("app-images", { attrs: { product: _vm.product } })],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          attrs: { "escape-close": "" },
          model: {
            value: _vm.translatedNamesModal,
            callback: function ($$v) {
              _vm.translatedNamesModal = $$v
            },
            expression: "translatedNamesModal",
          },
        },
        [
          _c("app-edit-translated-names", {
            on: {
              close: function ($event) {
                _vm.translatedNamesModal = false
              },
            },
            model: {
              value: _vm.product.TranslatedName,
              callback: function ($$v) {
                _vm.$set(_vm.product, "TranslatedName", $$v)
              },
              expression: "product.TranslatedName",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }